import API from "./../../config/api";

const getProductWebLink = function getProductWebLink(category, slug) {
    return `${API.endpoint.web}/${API.routes.product.index_path}/${category.slug}/${slug}`
};

export {
    getProductWebLink
}
